import React from "react";
import { Link } from "react-router-dom";
import { MdHome } from "react-icons/md";

const homeRoute = "/";

const PageNotFound = () => {
  return (
    <main className="relative flex min-h-screen items-center justify-center bg-white">
      {/* Subtle ambient glow */}
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-gradient-to-tr from-emerald-200 via-amber-200 to-purple-200 opacity-70 blur-3xl" />
        <div className="absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-gradient-to-tr from-purple-200 via-emerald-200 to-amber-200 opacity-70 blur-3xl" />
      </div>

      {/* Card */}
      <section
        role="alert"
        aria-live="polite"
        className="relative w-full max-w-md rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-2xl"
      >
        <p className="text-[72px] font-extrabold leading-none tracking-tighter">
          <span className="bg-gradient-to-r from-emerald-600 via-amber-600 to-purple-600 bg-clip-text text-transparent">
            404
          </span>
        </p>
        <h1 className="mt-2 text-xl font-semibold text-gray-900">Page not found</h1>
        <p className="mt-2 text-sm text-gray-600">
          The page you’re looking for might have been moved, deleted, or never existed.
        </p>

        <div className="mt-6 flex flex-col items-center justify-center gap-2 sm:flex-row">
          <Link
            to={homeRoute}
            className="inline-flex items-center justify-center rounded-xl bg-gray-900 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-gray-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
          >
            <MdHome className="mr-2 h-4 w-4" />
            Go to homepage
          </Link>

          <button
            type="button"
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center rounded-xl border border-gray-300 bg-white px-5 py-2.5 text-sm font-semibold text-gray-800 shadow-sm transition hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
          >
            Go back
          </button>
        </div>
      </section>
    </main>
  );
};

export default PageNotFound;
